import { GetInTouch } from '@/layout/Get-In-Touch';
import { Nav } from '@/layout/Nav';
import { ContactUs } from '@/layout/Contact-Us';
import { Footer } from '@/layout/Footer';
// eslint-disable-next-line
import { useLocation } from '@reach/router';
import { Script } from 'gatsby';

export const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const isNewhall = location.pathname === '/newhall/';
    return (
        <main>
            <Nav isNewhall={isNewhall} />
            {children}
            <GetInTouch isNewhall={isNewhall} />
            <ContactUs />
            <Footer />
            <Script src="https://cdn.callrail.com/companies/174510951/7701c7cb1e5d30c1e012/12/swap.js" />
        </main>
    );
};
